var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAddguest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 51
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-addguest_svg__a",
    x1: "89.052%",
    x2: "2.642%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4AFFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DBFCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.91 43.213l-1.623-1.622a.745.745 0 00-.53-.219.745.745 0 00-.53.22l-8.856 8.957-.108 3.098 2.843-.57 8.804-8.803a.745.745 0 00.219-.53.745.745 0 00-.22-.53zm-4.513-.692l3.428 3.365m-10.554 3.72l3.539 3.387",
    stroke: "#3B385E",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3B385E",
    strokeWidth: 2,
    transform: "translate(14 18)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 19.25V15.2A4.2 4.2 0 014.2 11h8.4a4.2 4.2 0 014.2 4.2v4.05h0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.4,
    cy: 4.125,
    rx: 4.2,
    ry: 4.125
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    d: "M15.4 22v-2.675a4.2 4.2 0 014.2-4.2h4.2a4.2 4.2 0 014.2 4.2V22h0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.7,
    cy: 8.938,
    fill: "#FFF",
    rx: 3.5,
    ry: 3.438
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 50,
    r: 2,
    fill: "url(#ic-addguest_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 5.5,
    r: 1.5,
    fill: "url(#ic-addguest_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 8,
    r: 1,
    fill: "url(#ic-addguest_svg__a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.5,
    cy: 37.5,
    r: 1.5,
    fill: "url(#ic-addguest_svg__a)"
  }))));
}
export default SvgIcAddguest;